<div class="card-content-field">
    <app-card-content [icon]="props.icon"
                      [currency]="props.currency"
                      [calculation]="(props?.evaluatedCalculationFunction?.(field) || props?.evaluatedCalculationFunction?.(field) === 0) ? props?.evaluatedCalculationFunction?.(field) : props.calculation"
                      [periodName]="props.periodName"
                      [detailedCalculation]="props.detailedCalculation"
                      [calculationSummary]="props.calculationSummary"
                      [title]="props.title"></app-card-content>
</div>
